const textFieldSignUp = {
  name: 'Nome Completo',
  email: 'Email',
  reason: 'Motivo do acesso'
};

export default textFieldSignUp;
